import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'ngbd-datepicker-range',
  templateUrl: './datepicker-range.html',
  styleUrls: ['./datepicker-range.css']
})
export class NgbdDatepickerRange {
  hoveredDate: NgbDate | null = null;
  @Input() title: NgbDate | null;
  @Input() fromDate: NgbDate | null;
  @Input() toDate: NgbDate | null;

  @ViewChild('datepicker', { static:false}) datePickerS: ElementRef;

  @Output() updateDates = new EventEmitter()
  


  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    // this.dateFrom.emit(this.fromDate);
    // this.dateTo.emit(this.toDate);
  }
  onDateSelection(date: NgbDate,datepickerF: NgbInputDatepicker) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      datepickerF.toggle();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.updateDates.emit({from: this.fromDate, to: this.toDate});
    
  }
  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }
  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
}